import { render, staticRenderFns } from "./publishBaseInfo.vue?vue&type=template&id=12d8bd8a&scoped=true&"
import script from "./publishBaseInfo.vue?vue&type=script&lang=js&"
export * from "./publishBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./publishBaseInfo.vue?vue&type=style&index=0&id=12d8bd8a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d8bd8a",
  null
  
)

export default component.exports